import styled from 'styled-components';
import { darken } from 'polished';

const ButtonIcon = styled.span`
  vertical-align: baseline;
  line-height: 1em;
`;

export const PrependedIcon = styled(ButtonIcon)`
  margin-right: 0.5em;
`;

export const AppendedIcon = styled(ButtonIcon)`
  margin-left: 1em;
`;

export const ChildrenWrapper = styled.div`
  display: inline-block;
`;

export const getButtonStyles = props => {
  // ( desired height - line height - border size ( both sides) ) / topAndBottom
  let padding = 'calc( (45px - 1em - 2px) / 2 ) 1.5em';
  let color = '#585454';
  let iconColor;
  let background = 'transparent';
  let hoverBackground = 'transparent';
  let fontSize = '16px';
  let fontWeight = 'normal';
  let border = 'none';
  let borderRadius = '4px';
  let boxShadow = 'none';
  let minWidth = '0';
  let borderBottom = 'none';

  switch (props.size) {
    case 'small':
      padding = '0.5em 2em';
      fontSize = '13px';
      break;
    case 'big':
      fontSize = '19px';
      break;
    case 'massive':
      padding = '1.5em 2em';
      break;
    default:
  }

  switch (props.appearance) {
    case 'primary':
      color = '#ffffff';
      iconColor = '#ffffff';
      boxShadow = '0px 1px 2px rgba(55, 65, 81, 0.08)';
      switch (props.version) {
        case 'abby':
          background = '#00ab9f';
          hoverBackground = '#00ab9f';
          borderBottom = '4px solid #00948a';

          break;
        case 'legacy':
        default:
          background = props.theme.legacy.colors.brand || '#0078D4';
          hoverBackground = darken(0.1, props.theme.legacy.colors.brand || '#1960A6');
          border = `1px solid ${props.theme.legacy.colors.brand || '#0078D4'}`;
          borderBottom = `1px solid ${props.theme.legacy.colors.brand || '#0078D4'}`;
      }
      break;
    case 'danger':
      color = '#ffffff';
      iconColor = '#ffffff';
      background = '#C7094D';
      hoverBackground = '#A60048';
      border = '1px solid #C7094D';
      borderBottom = '1px solid #C7094D';
      break;
    case 'secondary':
      color = '#494F5A';
      border = `1px solid ${props.theme.legacy.colors.brand || '#8F959F'}`;
      borderBottom = `1px solid ${props.theme.legacy.colors.brand || '#8F959F'}`;
      hoverBackground = '#F4F5F7';
      background = '#FFFFFF';
      iconColor = `${props.theme.legacy.colors.brand || '#494F5A'}`;
      break;
    case 'link':
      padding = '0';
      break;
    case 'highlightedLink':
      color = '#0078D4';
      iconColor = '#0078D4';
      padding = '0';
      break;
    case 'shadow':
      borderRadius = '8px';
      boxShadow = '0 1px 2px 0 rgba(0, 0, 0, 0.28)';
      fontWeight = 'bold';
      color = 'rgb(102, 102, 102)';
      iconColor = 'rgb(102, 102, 102)';
      padding = '0.8em 1.2em';
      fontSize = '16px';
      break;
    default:
  }

  switch (props.version) {
    case 'abby':
      borderRadius = '2em';
      fontWeight = 'bold';
      minWidth = '195px';

      break;
    case 'legacy':
    default:
      borderRadius = '4px';
      fontWeight = 'normal';
      minWidth = '0';
  }

  return `
    padding: ${padding};
    color: ${color};
    background: ${background};
    font-size: ${fontSize};
    border: ${border};
    border-radius: ${borderRadius};
    box-shadow: ${boxShadow};
    font-weight: ${fontWeight};
    min-width: ${minWidth};
    border-bottom: ${borderBottom};
    transition: background 0.2s ease;

    ${ButtonIcon} {
      ${iconColor && `color: ${iconColor};`}
    }

    &:not(.disabled):hover,
    &:not(.disabled):focus,
    &:not(.disabled):active {
      background: ${hoverBackground};
    }

    &:disabled {
      opacity: 0.3;
      pointer-events: none;
    }
  `;
};

export const newButtonDefaults = `
  height: auto;
  line-height: 1em;
  font-weight: normal;
  margin: 0;
  overflow: visible;
  text-shadow: none;
  white-space: nowrap;

  &:not(.disabled):hover,
  &:not(.disabled):focus,
  &:not(.disabled):active {
    text-shadow: none;
  }

  box-sizing: border-box;
  display: inline-block;
`;
